<template>
  <a-form class="set-password" :form="setPasswordForm" @submit="handleSubmit">
    <a-form-item
      v-if="routeName !== 'ForgetPwd'"
      label="输入原密码"
      :colon="false"
      :label-col="{ span: 6 }"
      :wrapper-col="{ span: 18 }"
    >
      <div class="input-area">
        <a-input
          v-decorator="[
            'oldPassword',
            {
              rules: [
                { required: true, message: '请输入原密码' }
              ],
              validateTrigger: 'blur'
            }
          ]"
          class="deep-bg-input"
          style="height: 36px;"
          :type="showOrigin ? 'text' : 'password'"
          placeholder="密码长度在6-20个字符之间"
        >
          <a-button slot="suffix" class="toggle-psw-btn" type="link" @click="showOrigin = !showOrigin">
            <sass-icon :type="showOrigin ? 'hi-xianshimima' : 'hi-yincangmima'" style="font-size: 16px;" />
          </a-button>
        </a-input>
      </div>
    </a-form-item>
    <a-form-item label="输入新密码" :colon="false" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
      <div class="input-area">
        <a-input
          v-decorator="[
            'newPassword',
            {
              rules: [
                { validator: oldPswValidator }
              ],
              validateTrigger: 'blur'
            }
          ]"
          size="large"
          class="deep-bg-input"
          :type="showNew ? 'text' : 'password'"
          placeholder="密码长度在6-20个字符之间"
          @change="errMsg = ''"
        >
          <a-button slot="suffix" class="toggle-psw-btn" type="link" @click="showNew = !showNew">
            <sass-icon :type="showNew ? 'hi-xianshimima' : 'hi-yincangmima'" style="font-size: 16px;" />
          </a-button>
        </a-input>
      </div>
    </a-form-item>
    <a-form-item label="确认新密码" :colon="false" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
      <div class="input-area">
        <a-input
          v-decorator="[
            'newPassword1',
            {
              rules: [
                { validator: confirmPswValidator }
              ],
              validateTrigger: 'blur'
            }
          ]"
          size="large"
          class="deep-bg-input"
          :type="showRe ? 'text' : 'password'"
          placeholder="密码长度在6-20个字符之间"
          @change="errMsg = ''"
        >
          <a-button slot="suffix" class="toggle-psw-btn" type="link" @click="showRe = !showRe">
            <sass-icon :type="showRe ? 'hi-xianshimima' : 'hi-yincangmima'"  style="font-size: 16px;" />
          </a-button>
        </a-input>
      </div>
      <p v-show="errMsg" class="err-msg">{{ errMsg }}</p>
    </a-form-item>
    <a-form-item>
      <a-button type="primary" htmlType="submit" class="info-btn" size="large" block>完成</a-button>
    </a-form-item>
  </a-form>
</template>
<script>
import CommonIcon from '@/components/common-icon'
import { modifyPassword, resetPassword } from '@/api/login'
import { Base64 } from 'js-base64'
import { isSerialNumber, sameChar } from '@/utils/util'
import { mapGetters } from 'vuex'
export default {
  name: 'SetPassword',
  components: {
    CommonIcon
  },
  beforeRouteEnter(to, from, next) {
    const fromName = from.name
    if (fromName === 'FVerifyPhone' || fromName === 'RVerifyPhone' || fromName === 'CVerifyPhone') {
      next()
    } else {
      next({ name: to.matched[to.matched.length - 2].name })
    }
  },
  data() {
    return {
      routeName: this.$attrs.parent,
      setPasswordForm: this.$form.createForm(this),
      showOrigin: false,
      showNew: false,
      showRe: false,
      errMsg: ''
    }
  },
  computed: {
    ...mapGetters(['mobile', 'userInfo'])
  },
  methods: {
    oldPswValidator(rule, value, callback) {
      const {
        mobile,
        userInfo: { accountCode }
      } = this
      if (!value) {
        callback(Error('请输入新密码'))
      } else if (value.length < 6 || value.length > 20) {
        callback(Error('新密码长度需在6-20个字符之间'))
      } else if (isSerialNumber(value)) {
        callback(Error('密码不可使用连续数字'))
      } else if (sameChar(value)) {
        callback(Error('密码不可使用连续相同字符'))
      } else if (value === mobile || value === accountCode) {
        callback(Error('密码不可与账号、手机号、微信号、邮箱相同'))
      } else {
        this.passwrod = value
        callback()
      }
    },
    confirmPswValidator(rule, value, callback) {
      if (!value) {
        callback(Error('请输入确认新密码'))
      } else if (this.passwrod && this.passwrod !== value) {
        callback(Error('两次输入的密码不一致'))
      }
      callback()
    },
    handleSubmit(e) {
      const { setPasswordForm, changePsw, resetPsw } = this
      e.preventDefault()
      setPasswordForm.validateFields((err, values) => {
        if (!err) {
          delete values.newPassword1
          for (const key in values) {
            values[key] = Base64.encode(values[key])
          }
          switch (this.routeName) {
            case 'First':
            case 'ChangeInitPwd':
              changePsw(values)
              break
            case 'ForgetPwd':
            default:
              resetPsw(values)
              break
          }
        }
      })
    },
    jumpDone() {
      // TODO 跳转完成前逻辑
      let nextName
      switch (this.routeName) {
        case 'First':
          nextName = 'FDone'
          break
        case 'ChangeInitPwd':
          nextName = 'CDone'
          break
        case 'ForgetPwd':
        default:
          nextName = 'RDone'
          break
      }
      this.$router.push({ name: nextName })
    },
    changePsw(data) {
      // 修改密码
      const { jumpDone, showErrMsg } = this
      modifyPassword(data)
        .then(() => {
          jumpDone()
        })
        .catch(err => {
          showErrMsg(err)
        })
    },
    resetPsw(data) {
      // 重置密码
      const { jumpDone, showErrMsg } = this
      const newdata = { ...data, ...this.$route.query }
      resetPassword(newdata)
        .then(() => {
          jumpDone()
        })
        .catch(err => {
          showErrMsg(err)
        })
    },
    showErrMsg(err) {
      if (err.code && err.msg) {
        const {
          setPasswordForm: { getFieldsValue, setFields }
        } = this
        const { code, msg, invalidField } = err
        const values = getFieldsValue()
        if (invalidField) {
          setFields({
            [invalidField]: {
              value: values[invalidField],
              errors: [
                {
                  field: invalidField,
                  message: msg
                }
              ]
            }
          })
        } else {
          switch (code) {
            case 'AUTHEN0011':
            case 'AUTHEN0004':
              setFields({
                oldPassword: {
                  value: values.oldPassword,
                  errors: [
                    {
                      field: 'oldPassword',
                      message: msg
                    }
                  ]
                }
              })
              break
            case 'AUTHEN0012':
            case 'AUTHEN0014':
              setFields({
                newPassword: {
                  value: values.newPassword,
                  errors: [
                    {
                      field: 'newPassword',
                      message: msg
                    }
                  ]
                },
                newPassword1: {
                  value: values.newPassword1,
                  errors: [
                    {
                      field: 'newPassword1',
                      message: msg
                    }
                  ]
                }
              })
              break
            default:
              this.errMsg = msg
              break
          }
        }
      } else {
        this.$notification.error({
          message: '错误',
          description: ((err.response || {}).data || {}).message || err.msg || '请求出现错误，请稍后再试',
          duration: 4
        })
      }
    }
  }
}
</script>
<style lang="less" scoped>
.info-btn {
  height: 36px !important;
}
/deep/input#newPassword {
  height: 36px !important;
}
/deep/input#newPassword1 {
  height: 36px !important;
}
// /deep/.ant-col.ant-form-item-control-wrapper {
//   height: 28px;
// }
.set-password {
  margin: 68px auto;
  width: 380px;
}
.input-area {
  display: flex;
  align-items: center;
  & > input {
    flex: 1;
  }
}
.toggle-psw-btn {
  padding-right: 0;
  color: #595959;
}
</style>
